import script from "./EditLicense.vue?vue&type=script&setup=true&lang=js"
export * from "./EditLicense.vue?vue&type=script&setup=true&lang=js"

import "./EditLicense.vue?vue&type=style&index=0&id=2db57f92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db57f92"]])

export default __exports__